const BASE_PATH = "app/notification/";

export const SET_WHO_PROFILE_VIEW = `${BASE_PATH}set-who-profile-view`;
export const SET_NOTIFICATION = `${BASE_PATH}set-notification`;